/**
 * @typedef {Object} Player
 * @property {string} name
 * @property {Leader} Leader
 * @property {Base} base
 * @property {number} remainingHp
 * @property {boolean} hasInitiative
 * @property {boolean} hasUsedEpicAction

 * @typedef {Object} StateSettings
 * @property {boolean} countUp
 * @property {string} bottomPlayerName


 * @typedef {Object} StateGame
 * @property {number} rounds
 * @property {Base} topBase
 * @property {Leader} topLeader
 * @property {Base} bottomBase
 * @property {Leader} bottomLeader
 * @property {SwuGameLogEntry[]} log
 * @property {number} startTime
 * @property {number} endTime
 * @property {boolean} ended

 * @typedef  LogType Claim | Damage | Heal | Initiative | EpicAction | GameStart | Reset | RoundEnd | Win
 * @typedef  Player top | bottom | none

 * @typedef {Object} SwuGameLogEntry
 * @property {string} message
 * @property {Player} player
 * @property {LogType} type
 * @property {number} value
 * @property {number} round
 * @property {number} timestamp
 * @property {number} timeInGame

 @typedef {Object} StateUiToggle
 @property {boolean} show
 @property {Player} player
 
 
 * @typedef {Object} StateUi
 * @property {StateUiToggle} showSettings
 * @property {StateUiToggle} showBaseModal
 * @property {StateUiToggle} showLeaderModal
 * @property {StateUiToggle} showPickWinnerModal
 * @property {StateUiToggle} showLog
 * @property {StateUiToggle} showInitiative
 
 * @typedef {Object} SwucState
 * @property {Player} top
 * @property {Player} bottom
 * @property {StateUi} ui
 * @property {StateSettings} settings
 * @property {StateGame | undefined} currentGame
 * @property {StateGame[]} games
 */

import { LoadGames } from "../assets/script/gameSession.js";
import { getReducers } from "./Reducers.js";

/**
 * @name GetState
 * @return {SwucState}
 * @constructor
 */
export function GetState() {
  if (window.swucState !== undefined) {
    return CloneState(window.swucState);
  }
  return InitState();
}

/**
 * @name CloneState
 * @param {SwucState} state
 * @return {SwucState}
 */
export function CloneState(state) {
  return JSON.parse(JSON.stringify(state));
}

/**
 * @name updateState
 * @param detail
 */
function updateState({ detail }) {
  const { action = "", payload } = detail;
  console.log("Action", action, payload);
  const reducers = getReducers();
  const oldState = CloneState(window.swucState);
  const newState = CloneState(window.swucState);
  if (reducers[action]) {
    const updatedState = reducers[action](newState, payload);
    window.swucState = CloneState(updatedState);
    //saveToLocalStorage(STATE_KEY, window.swucState);
    document.body.dispatchEvent(
      new CustomEvent("stateChanged", {
        detail: { state: window.swucState, old: oldState },
      })
    );
  }
}

const STATE_KEY = "swuc_state";
/**
 * @name InitState
 * @return {SwucState}
 * @constructor
 */
export function InitState() {
  document.body.addEventListener("updateState", updateState);
  //const localStorageState = getFromLocalStorage(STATE_KEY);

  /** @type {SwucState} */
  const state = {
    games: LoadGames(),
    currentGame: undefined,
    top: {
      name: "Top Player",
      leader: undefined,
      base: undefined,
      remainingHp: 30,
      hasInitiative: false,
      hasUsedEpicAction: false,
    },
    bottom: {
      name: "Bottom Player",
      leader: undefined,
      base: undefined,
      remainingHp: 30,
      hasInitiative: false,
      hasUsedEpicAction: false,
    },
    settings: {
      countUp: true,
    },
    ui: {
      showSettings: {
        show: false,
        player: "none",
      },
      showBaseModal: {
        show: false,
        player: "none",
      },
      showLeaderModal: {
        show: false,
        player: "none",
      },
      showPickWinnerModal: {
        show: false,
        player: "none",
      },
      showLog: {
        show: false,
        player: "none",
      },
      showInitiative: {
        show: false,
        player: "bottom",
      },
    },
  };

  window.swucState = state;
  DispatchAction("initState", state);
  return state;
}

/**
 * @name DispatchAction
 * @param {string} action
 * @param {any=} payload
 * @returns void
 */
export function DispatchAction(action, payload) {
  document.body.dispatchEvent(
    new CustomEvent("updateState", { detail: { action, payload } })
  );
}

/**
 * @name RegisterStateUpdatedListener
 * @param {function} listener
 * @returns void
 */
export function RegisterStateUpdatedListener(listener) {
  document.body.addEventListener("stateChanged", listener);
}

/**
 * @name RegisterActionListener
 * @param {string} action
 * @param {function} listener
 * @returns void
 */
export function RegisterActionListener(action, listener) {
  document.body.addEventListener("updateState", (e) => {
    if (e.detail.action === action) {
      listener(e.detail.payload);
    }
  });
}

/**
 * @name UnregisterStateUpdatedListener
 * @param {function} listener
 * @returns void
 */
export function UnregisterStateUpdatedListener(listener) {
  document.body.removeEventListener("stateChanged", listener);
}
